/// <reference types="@angular/localize" />

import { importProvidersFrom } from '@angular/core';
import '@angular/localize/init';
import { bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter, withViewTransitions } from '@angular/router';
import { initializeInternalAuth } from '@eforall/common';
import { environment } from './environments/environment';
import { BootstrapPage } from './pages/bootstrap/bootstrap.page';
import { routes } from './routes';


async function bootstrap() {

	await initializeInternalAuth(environment);

	bootstrapApplication(
		BootstrapPage,
		{
			providers: [
				provideRouter(routes, withViewTransitions()),	// , withDebugTracing()),
				importProvidersFrom([BrowserAnimationsModule]),
			]
		}
	).catch((err) => console.error(err));
}


bootstrap();